export default __webpack_public_path__ + "static/media/luxuary-car2.c9d0d752.png";